import * as actions from './eStoreCatalog/actions'
import * as mutations from './eStoreCatalog/mutations'
import * as getters from './eStoreCatalog/getters'

import { dataProps } from './eStoreCatalog/properties'

const state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '', 
        search_term_array: []
    },
    request_list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreCatalog.js